import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { formatMessage } from '@99designs/frontend-components/i18n';
import HeartIcon from '../../../../shared/components/Icon/components/Heart1';
import PinIcon from '../../../../shared/components/Icon/components/Pin1';
import StarIcon from '../../../../shared/components/Icon/components/Star2';
import TrophyIcon from '../../../../shared/components/Icon/components/Trophy1';
import Link from '../../../../shared/components/Link';
import { colors, media, spaces } from '../../../../shared/lib/styles';
import Stack from '../../../../shared/spa/core-components/Stack/Stack';
import StatsItem from './StatsItem';

const StyledStats = styled.div`
    display: flex;
    align-items: center;
    width: 300px;

    @media ${media('small')} {
        width: 270px;
    }
`;

const Divider = styled.div`
    content: '';
    width: 70px;
    height: 1px;
    background: ${colors.grey300};
`;

const Stats = () => {
    const intl = useIntl();

    return (
        <StyledStats>
            <Stack space="space9">
                <StatsItem
                    icon={<StarIcon fontSize={28} />}
                    title={__('4.8/5 rating')}
                    description={
                        <>
                            {__(`That’s our average customer rating from `)}
                            <Link href="/testimonials/logo-design">
                                {formatMessage(__('{reviewCount} reviews'), {
                                    reviewCount: intl.formatNumber(26035),
                                })}
                            </Link>
                        </>
                    }
                />
                <Divider />
                <StatsItem
                    icon={<PinIcon fontSize={28} />}
                    title={__('24/7 creativity')}
                    description={__('Professional designers online and available worldwide')}
                />
                <Divider />
                <StatsItem
                    icon={<HeartIcon fontSize={28} />}
                    title={intl.formatNumber(417789)}
                    description={__('Happy logo design clients to date')}
                />
                <Divider />
                <StatsItem
                    icon={<TrophyIcon fontSize={28} />}
                    title={intl.formatNumber(634)}
                    description={__('Open contests right now')}
                />
            </Stack>
        </StyledStats>
    );
};

export default Stats;
